<template>
  <div id="EquipmentCurrentStatus">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Out Of Service Details</div>
          <div class="web-action-btn btn-groups text-right">
            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
              <i class="fp-export"></i> Export
            </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'outOfServiceDetails'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'outOfServiceDetails'" :position="'top'">
                </custom-pagination>

                <vue-good-table
                  mode="remote"
                  ref="outOfServiceDetailsTable"
                  title="outOfServiceDetails"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                            enabled: false,
                            position: 'both',
                            perPage: perPage,
                            dropdownAllowAll: false,
                            setCurrentPage:listCurrentPage,
                            perPageDropdown:dropDownPerPage,
                        }"
                  :select-options="{
                            enabled: true,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                        }"
                  :search-options="{
                        enabled: false,
                        }"

                >
                </vue-good-table>
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {

  name: "OutOfServiceDetails",
  metaInfo(){
    return {
      title : 'Out Of Service Details | FleetPro Application'
    }
  },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action : 'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
      {
        label: 'Domicile Facility',
        field: 'assigned_facility',
        fpFieldType: "option",
        filterable: true,
        hidden: false,
        width: '90px',
      },
      {
        label: 'Repair Facility',
        field: 'location',
        fpFieldType: "option",
        filterable: true,
        hidden: false,
      },
      {
        label: "Unit",
        field: "unit_no",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: "Eq Sts",
        field: "vehicle_status",
        filterable: true,
        fpFieldType: "option",
        hidden: false,
        width: '90px',
        filterOptions: {
          filterDropdownItems: ["Active(A)", "In Garage(I)", "Sold(S)", "Void(V)"]
        }
      },
      {
        label: "Eq Pool",
        field: "pool",
        filterable: true,
        fpFieldType: "option",
        hidden: false,
        width: '90px',
      },
      {
        label: "Eq Type",
        field: "equip_type",
        filterable: true,
        fpFieldType: "option",
        hidden: false,
        width: '90px',
      },
      {
        label: "OOS Date",
        field: "start_date",
        filterable: true,
        fpFieldType: "custom_date",
        hidden: false,
      },
      {
        label: "Days OOS",
        field: "days_oos",
        filterable: false,
        fpFieldType: "date",
        hidden: false,
        sortable: false
      },
      {
        label: 'OOS User',
        field: 'created_by',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Work Order',
        field: 'work_order_no',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Pty',
        field: 'pty',
        sortable: false,
        fpFieldType: "text",
        filterable: false,
        hidden: false,
      },
      {
        label: 'WO sts',
        field: 'status',
        fpFieldType: "option",
        filterable: true,
        hidden: false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Status", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          filterDropdownItems: ['Approved', 'Closed', 'Open', 'In Progress', 'Review'],
          trigger: "enter" //only trigger on enter not on keyup
        },
      },
      {
        label: 'Sub Unit',
        field: 'sub_unit',
        fpFieldType: "text",
        sortable: true,
        filterable: true,
        hidden: false,
        width: '90px',
      },
      {
        label: "Rental Contract",
        field: "agreement_number",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: "Contract Customer Name",
        field: "contract_customer",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: "Work Order Out of Service Comments",
        field: "work_order_out_of_service_comments",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: "Out of Service General Comments",
        field: "out_of_service_general_comments",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: "Next PM Date",
        field: "next_pm_date",
        filterable: false,
        sortable: false,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: "Due Now ?",
        field: "due_now",
        filterable: false,
        sortable: false,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: "Current Customer Company Code ?",
        field: "current_customer_code",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: "Current Customer Number ?",
        field: "current_customer_number",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: "Current Customer Suffix ?",
        field: "current_customer_suffix",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: 'Current Customer',
        field: 'current_customer',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        width: '90px',
      },
      {
        label: "Current Customer Name",
        field: "current_customer_name",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: "Billable WO Lines?",
        field: "billable_wo_line",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
      var self = this;
      permission.forEach(function (permissions) {
        if(permissions.name == 'out_of_service_history') {
          self.cantAccessPage = true;
        }
      });
      if(self.cantAccessPage == ''){
        self.cantAccessPage = false;
      }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },

  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.outOfServiceDetailsTable.unselectAllInternal();
    },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();
      var selectedRows = [];
      var data = this.$refs['outOfServiceDetailsTable'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
        selectedRows.push(this.$refs['outOfServiceDetailsTable'].selectedRows[i].id)
      }
      var filterAll = self.serverParams.columnFilters;
      if ( self.action == "export" ) {
        filterAll = self.removeOptionArr(self.serverParams.columnFilters);
      }

      $.ajax({
        url: process.env.ROOT_API + "/out-of-service-details/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: filterAll,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,


        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {
            if (self.action == "export" ||  self.action == "export_queue") {

              if ( data.code == "201" ) {
                alert(data.message);
              } else {

                if ( self.action == "export" ) {

                  self.excel = data.content.web;
                  var save = document.createElement("a");
                  save.href = self.excel;
                  save.download = data.content.web;
                  save.target = "_blank";

                  document.body.appendChild(save);
                  save.click();
                  document.body.removeChild(save);

                } else {

                  self.batchProcess = 1;
                  self.batchNum = data.content;
                }

              }

              self.action = "list";
              // self.loadList();
            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR,true,'equipment-current-status')
        }
      });
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/OutOfServiceDetails.vue